import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  return (
    <div className="bg-[#0b1017] text-slate-100 min-h-screen">
      <SEO
        title="Kontakt | JARCon"
        description="Kontakt mig i dag! Telefon: +45 22 88 45 36, Email: jens@jarcon.dk, Adresse: Toftehøj 21, 6470 Sydals, Produktionsadresse: Huholt 1A, 6400 Sønderborg, CVR: 39150255"
      />

      <PageHeader
        badge="Kontaktinformation"
        title="Kontakt mig i dag!"
        subtitle="Har du en opgave inden for mekanisk konstruktion, elkonstruktion, automation eller produktionsudstyr?"
        breadcrumbs={[{ label: 'Kontakt' }]}
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          {/* Company Contact Details */}
          <div className="lg:col-span-5 space-y-8">
            <div className="p-8 rounded-2xl bg-[#0e1622] border border-slate-800 space-y-6">
              <div>
                <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-widest font-semibold block mb-1">
                  Virksomhedsoplysninger
                </span>
                <h2 className="font-display text-2xl font-bold text-white">
                  JARCon ApS
                </h2>
                <p className="text-sm text-slate-400 font-open-sans mt-1">
                  CVR: 39150255
                </p>
              </div>

              <div className="space-y-4 pt-4 border-t border-slate-800 text-sm font-sans">
                {/* Telefon */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-950/80 border border-cyan-500/40 text-cyan-400 flex items-center justify-center shrink-0 text-base">
                    <i className="fa-solid fa-phone" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="block text-xs font-open-sans uppercase text-slate-400">Telefon</span>
                    <a
                      href="tel:+4522884536"
                      className="text-base font-semibold text-white hover:text-cyan-400 transition-colors whitespace-nowrap"
                    >
                      +45 22 88 45 36
                    </a>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-950/80 border border-cyan-500/40 text-cyan-400 flex items-center justify-center shrink-0 text-base">
                    <i className="fa-solid fa-envelope" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="block text-xs font-open-sans uppercase text-slate-400">Email</span>
                    <a
                      href="mailto:jens@jarcon.dk"
                      className="text-base font-semibold text-white hover:text-cyan-400 transition-colors whitespace-nowrap"
                    >
                      jens@jarcon.dk
                    </a>
                  </div>
                </div>

                {/* Adresse */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-950/80 border border-cyan-500/40 text-cyan-400 flex items-center justify-center shrink-0 text-base">
                    <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="block text-xs font-open-sans uppercase text-slate-400 font-semibold text-cyan-300">
                      Adresse
                    </span>
                    <p className="text-white font-medium">
                      Toftehøj 21<br />
                      6470 Sydals
                    </p>
                  </div>
                </div>

                {/* Produktionsadresse */}
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-cyan-950/80 border border-cyan-500/40 text-cyan-400 flex items-center justify-center shrink-0 text-base">
                    <i className="fa-solid fa-industry" aria-hidden="true" />
                  </div>
                  <div>
                    <span className="block text-xs font-open-sans uppercase text-slate-400 font-semibold text-cyan-300">
                      Produktionsadresse
                    </span>
                    <p className="text-white font-medium">
                      Huholt 1A<br />
                      6400 Sønderborg
                    </p>
                  </div>
                </div>
              </div>

              {/* Map link button */}
              <div className="pt-4 border-t border-slate-800 space-y-2">
                <a
                  href="https://maps.google.com/maps?q=Huholt+1A,+6400+S%C3%B8nderborg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full inline-flex items-center justify-center gap-2 py-3 px-4 rounded-lg bg-slate-900 hover:bg-slate-800 text-slate-300 hover:text-white border border-slate-700 text-xs font-open-sans transition-colors"
                >
                  <i className="fa-solid fa-map-location-dot text-cyan-400" aria-hidden="true" />
                  <span>Produktion: Find vej til Huholt 1A, Sønderborg</span>
                </a>
                <a
                  href="https://maps.google.com/maps?q=Tofteh%C3%B8j+21,+6470+Sydals"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full inline-flex items-center justify-center gap-2 py-2 px-4 rounded-lg bg-slate-900/50 hover:bg-slate-800/80 text-slate-400 hover:text-slate-200 border border-slate-800 text-xs font-open-sans transition-colors"
                >
                  <i className="fa-solid fa-location-dot text-slate-400" aria-hidden="true" />
                  <span>Kontor: Toftehøj 21, 6470 Sydals</span>
                </a>
              </div>
            </div>

            {/* JARC Audio note (privat projekt uden erhvervsmæssig sammenhæng) */}
            <div className="p-4 rounded-xl bg-[#0e1622]/80 border border-slate-800 flex items-center justify-between gap-4">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-lg bg-slate-900 text-cyan-400 border border-slate-800 flex items-center justify-center shrink-0">
                  <i className="fa-solid fa-volume-high text-xs" aria-hidden="true" />
                </div>
                <div>
                  <span className="text-xs font-semibold text-white block">Søger du JARC Audio?</span>
                  <span className="text-[11px] text-slate-400">Privat hifi- og højttalerprojekt (ikke erhverv)</span>
                </div>
              </div>
              <a
                href="https://d6e713fb-6411-4075-ab6a-5936b7a50d5a.sites.auxodev.dk/"
                target="_blank"
                rel="noopener noreferrer"
                className="shrink-0 text-xs text-cyan-400 hover:text-cyan-300 font-semibold inline-flex items-center gap-1.5 px-3 py-1.5 rounded bg-slate-900 border border-slate-700/80 transition-colors"
              >
                <span>Besøg site</span>
                <i className="fa-solid fa-arrow-up-right-from-square text-[10px]" aria-hidden="true" />
              </a>
            </div>

            {/* Quick response commitment */}
            <div className="p-6 rounded-xl bg-slate-900/60 border border-slate-800 space-y-2">
              <span className="text-xs font-open-sans text-cyan-400 uppercase tracking-wider block font-semibold">
                Direkte dialog
              </span>
              <p className="text-xs text-slate-300 leading-relaxed">
                Hos JARCon taler du direkte med den udførende ingeniør. Det giver lynhurtig teknisk afklaring og ingen unødvendige mellemled.
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-7">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
}
